import { AuthState } from "@okta/okta-auth-js";

export const parseIdTokenPayload = (
  authState: AuthState | null,
): Record<string, unknown> => {
  if (!authState?.idToken) return {};

  try {
    return JSON.parse(atob(authState.idToken.idToken.split(".")[1]));
  } catch (error) {
    return {};
  }
};

export const isPatientUser = (authState: AuthState | null): boolean =>
  parseIdTokenPayload(authState).isPatientUser === true;
